<div class="container">
  <div [ngClass]="toggleProperty ? 'flipped' : ''" class="card">
    <div class="front">
      
      <!-- content projection-->
      <ng-content select="app-flip-card-front"></ng-content>
      <!-- content projection-->

      <div class="content-flip-container">

        <!-- content projection-->
        <ng-content select="content-at-front-arrow"></ng-content>
        <!-- content projection-->

        <div class="arrow-icon" (click)="toggle()">
          <span class="material-symbols-outlined">arrow_forward</span>
        </div>

      </div>

    </div>
    <div class="back">

      <!-- content projection-->
      <ng-content select="app-flip-card-back"></ng-content>
      <!-- content projection-->

      <div class="content-flip-container">

        <!-- content projection-->
        <ng-content select="content-at-back-arrow"></ng-content>
        <!-- content projection-->

        <div class="arrow-icon" (click)="toggle()">
          <span class="material-symbols-outlined">arrow_back</span>
        </div>

      </div>

    </div>
  </div>
</div>
